import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex justify-center flex-grow text-white pb-5" }
const _hoisted_2 = { class: "absolute h-3 w-3 right-0 rounded-full bg-next-orange" }
const _hoisted_3 = {
  key: 0,
  class: "absolute left-[87%] bottom-5 p-3 pr-10 bg-white cursor-pointer",
  style: {"box-shadow":"0 0 60px rgba(0,0,0,0.16)"}
}
const _hoisted_4 = { class: "text-next-neu flex flex-col text-left whitespace-nowrap cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cm_visible = !_ctx.cm_visible)),
      class: "self-end relative rounded-full bg-white aspect-square h-10"
    }, [
      _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [
        [_vShow, _ctx.notification]
      ])
    ]),
    (_ctx.cm_visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.hasPermission('access admin'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {name:'HomePermessi'},
                  onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cm_visible=false)),
                  class: "hover:text-next-dark-gray mb-2"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("Admin ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: {name:'ProfiloUtente'},
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cm_visible=false)),
              class: "hover:text-next-dark-gray mb-2"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Profilo ")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name:'Configurazioni'},
              onClickCapture: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cm_visible=false)),
              class: "hover:text-next-dark-gray mb-2"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Configurazioni ")
              ])),
              _: 1
            }),
            (_ctx.me.responsabile_di_count > 0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: {name:'ControlloTimesheet'},
                  onClickCapture: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cm_visible=false)),
                  class: "hover:text-next-dark-gray mb-2"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Controllo timesheet ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: {name:'Support'},
              onClickCapture: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cm_visible=false)),
              class: "hover:text-next-dark-gray mb-2"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Supporto ")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name:'DownloadCenter'},
              onClickCapture: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cm_visible=false)),
              class: "hover:text-next-dark-gray mb-2"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("Download center ")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {name:'Logout'},
              onClickCapture: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cm_visible=false)),
              class: "hover:text-next-dark-gray font-bold"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("Logout ")
              ])),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}